import Cookies from "js-cookie";
import { useCallback, useEffect } from "react";
import { useAuthUser } from "./useAuthUser";
import { useCustomerManagementStore } from "./store";

const googleAnalyticsKey = "_ga";
const googleAnalyticsMeasurementId = "_ga_L7WTSSQZVM";

export const useGoogleAnalytics = () => {
  const { isAuthenticated } = useAuthUser();
  const { monitorClients } = useCustomerManagementStore();

  const getGoogleClientId = useCallback(() => {
    return Cookies.get(googleAnalyticsKey);
  }, []);

  const getGoogleSessionId = useCallback(() => {
    return Cookies.get(googleAnalyticsMeasurementId);
  }, []);

  useEffect(() => {
    if (isAuthenticated && process.env.REACT_APP_IS_PRODUCTION === "true") {
      monitorClients({
        clientId: getGoogleClientId(),
        sessionId: getGoogleSessionId(),
      });
    }
  }, [getGoogleClientId, getGoogleSessionId, isAuthenticated, monitorClients]);

  return { getGoogleClientId, getGoogleSessionId };
};
